import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  CircularProgress,
  TextField,
  Stack,
  Alert,
} from '@mui/material';
import AuthShell, {
  authAlertSx,
  authFieldSx,
  authPrimaryButtonSx,
  authSecondaryButtonSx,
} from '../components/auth/AuthShell';

const SignupPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    setLoading(true);
    try {
      const payload = {
        user_id: 0,
        email,
        password,
        username: email?.split('@')[0] || email,
        service_name: 'ちりり競馬',
        memo: '',
      };

      const res = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        const detail = data?.detail || '登録に失敗しました';
        throw new Error(detail);
      }

      setMessage('登録が完了しました。ログインしてください。');
      setTimeout(() => navigate('/login'), 800);
    } catch (err) {
      setError(err.message || '登録に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="User Onboarding"
      title="ユーザー登録"
      description="メールアドレスとパスワードを登録すると、AI予想ダッシュボードと関連機能を利用できるようになります。"
      sideTitle="ちりり競馬"
      sideBody="新規登録後はログイン画面へ戻り、そのまま分析ページに入れます。アカウント作成はこの画面だけで完結します。"
    >
      <Stack spacing={2.5}>
        {error && (
          <Alert severity="error" onClose={() => setError('')} sx={authAlertSx}>
            {error}
          </Alert>
        )}
        {message && (
          <Alert severity="success" onClose={() => setMessage('')} sx={authAlertSx}>
            {message}
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="メールアドレス"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              sx={authFieldSx}
            />
            <TextField
              label="パスワード"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              sx={authFieldSx}
            />
            <Button type="submit" variant="contained" disabled={loading} sx={authPrimaryButtonSx}>
              {loading ? <CircularProgress size={22} sx={{ color: '#04111c' }} /> : '登録する'}
            </Button>
            <Button variant="outlined" onClick={() => navigate('/login')} sx={authSecondaryButtonSx}>
              ログインへ戻る
            </Button>
          </Stack>
        </form>
      </Stack>
    </AuthShell>
  );
};

export default SignupPage;
